module.exports = __webpack_public_path__ + "418ba7856dfbb0e2848b512734d7fb34.fbx";